// extracted by mini-css-extract-plugin
export var chip = "_my-2";
export var chipBody = "_my-8";
export var chipHeader = "_my-9";
export var chipWithKind = "_my-7";
export var icon = "_my-3";
export var kind = "_my-a";
export var remove = "_my-5";
export var removeIcon = "_my-6";
export var row = "_my-0";
export var rowHistorical = "_my-1";
export var text = "_my-4";